import { inject } from 'aurelia';
import { getLogger } from '../common/logging';
import { IRouter } from '@aurelia/router';
import { ApiClient } from './api-client';
import { CurrentRoute } from '../current-route';
let log = getLogger('http-service-base');

@inject(ApiClient, IRouter, CurrentRoute)
export class HttpServiceBase {
  constructor(http, router, currentRoute) {
    this.http = http;
    this.router = router;
    this.currentRoute = currentRoute;
  }

  handleError(e) {
    log.error(e);
    if (e.isSuccess) return;

    // In control-edit the page is framed by Control, which handles an expired
    // token itself; a redirect would put the login page inside its frame.
    if (e.statusCode === 401 && this.currentRoute.name !== "control-edit") {
      this.router.load(`/${this.currentRoute.params.customer}/login`);
    }
  }
}
